<template>
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      :fill="fillColor"
      d="M25.0699 9.23C23.4599 9.07 21.8499 8.95 20.2299 8.86V8.85L20.0099 7.55C19.8599 6.63 19.6399 5.25 17.2999 5.25H14.6799C12.3499 5.25 12.1299 6.57 11.9699 7.54L11.7599 8.82C10.8299 8.88 9.89991 8.94 8.96991 9.03L6.92991 9.23C6.50991 9.27 6.20991 9.64 6.24991 10.05C6.28991 10.46 6.64991 10.76 7.06991 10.72L9.10991 10.52C14.3499 10 19.6299 10.2 24.9299 10.73C24.9599 10.73 24.9799 10.73 25.0099 10.73C25.3899 10.73 25.7199 10.44 25.7599 10.05C25.7899 9.64 25.4899 9.27 25.0699 9.23Z"
    />
    <path
      :fill="fillColor"
      d="M23.23 12.14C22.99 11.89 22.66 11.75 22.32 11.75H9.67999C9.33999 11.75 8.99999 11.89 8.76999 12.14C8.53999 12.39 8.40999 12.73 8.42999 13.08L9.04999 23.34C9.15999 24.86 9.29999 26.76 12.79 26.76H19.21C22.7 26.76 22.84 24.87 22.95 23.34L23.57 13.09C23.59 12.73 23.46 12.39 23.23 12.14ZM17.66 21.75H14.33C13.92 21.75 13.58 21.41 13.58 21C13.58 20.59 13.92 20.25 14.33 20.25H17.66C18.07 20.25 18.41 20.59 18.41 21C18.41 21.41 18.07 21.75 17.66 21.75ZM18.5 17.75H13.5C13.09 17.75 12.75 17.41 12.75 17C12.75 16.59 13.09 16.25 13.5 16.25H18.5C18.91 16.25 19.25 16.59 19.25 17C19.25 17.41 18.91 17.75 18.5 17.75Z"
    />
  </svg>
</template>

<script>
export default {
  name: 'TrashIcon',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    fillColor() {
      return this.disabled ? '#00000040' : '#E31A1A'
    },
  },
}
</script>
